// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auditEventExchangeDetails_label__NXCLI {
    margin: 0 1rem 1rem 0;
    line-height: 1.2rem;
}

.auditEventExchangeDetails_alertTitle__IikBR {
    margin-left: 1rem;
}

.auditEventExchangeDetails_headerTableContainer__9ULfu {
    background-color: var(--gray);
}

.auditEventExchangeDetails_tableTitle__xsOEd {
    text-align: center;
    font-size: var(--title-3-desktop-size);
    font-style: var(--title);
    font-weight: 100;
}

.auditEventExchangeDetails_table__bkYOo {
    margin-left: 1rem;
}

.auditEventExchangeDetails_responseSection__9nUrH {
    width: 100%;
}

.auditEventExchangeDetails_responseCard__vOx8h {
    width: 100%;
}

.auditEventExchangeDetails_auditTable__3YYIv {
    margin-top: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/auditEventExchangeDetails/auditEventExchangeDetails.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".label {\n    margin: 0 1rem 1rem 0;\n    line-height: 1.2rem;\n}\n\n.alertTitle {\n    margin-left: 1rem;\n}\n\n.headerTableContainer {\n    background-color: var(--gray);\n}\n\n.tableTitle {\n    text-align: center;\n    font-size: var(--title-3-desktop-size);\n    font-style: var(--title);\n    font-weight: 100;\n}\n\n.table {\n    margin-left: 1rem;\n}\n\n.responseSection {\n    width: 100%;\n}\n\n.responseCard {\n    width: 100%;\n}\n\n.auditTable {\n    margin-top: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `auditEventExchangeDetails_label__NXCLI`,
	"alertTitle": `auditEventExchangeDetails_alertTitle__IikBR`,
	"headerTableContainer": `auditEventExchangeDetails_headerTableContainer__9ULfu`,
	"tableTitle": `auditEventExchangeDetails_tableTitle__xsOEd`,
	"table": `auditEventExchangeDetails_table__bkYOo`,
	"responseSection": `auditEventExchangeDetails_responseSection__9nUrH`,
	"responseCard": `auditEventExchangeDetails_responseCard__vOx8h`,
	"auditTable": `auditEventExchangeDetails_auditTable__3YYIv`
};
export default ___CSS_LOADER_EXPORT___;
